import React from 'react';
import { ui } from './ui';
import { CLASS_LIST, SUBJECTS, EXAM_TITLES } from './paperUtils';

const readLogo = (file, cb) => {
  if (!file) return;
  if (file.size > 600 * 1024) { alert('Logo must be under 600 KB.'); return; }
  const r = new FileReader();
  r.onload = () => cb(String(r.result));
  r.readAsDataURL(file);
};

// Metadata, header/branding, typography & layout controls.
export default function SettingsPanel({ paper, setPaper, scope, autoTotal }) {
  const h = paper.headerConfig;
  const set = (patch) => setPaper((p) => ({ ...p, ...patch }));
  const setH = (patch) => setPaper((p) => ({ ...p, headerConfig: { ...p.headerConfig, ...patch } }));
  const classes = scope && !scope.all && scope.classes.length ? CLASS_LIST.filter((c) => scope.classes.includes(c.toLowerCase())) : CLASS_LIST;
  const subjects = scope && !scope.all && scope.subjects.length
    ? SUBJECTS.filter((s) => scope.subjects.includes(s.toLowerCase())).concat(scope.subjects.filter((s) => !SUBJECTS.some((x) => x.toLowerCase() === s)))
    : SUBJECTS;

  return (
    <div>
      <div style={ui.card}>
        <span style={ui.label}>Paper title</span>
        <input style={ui.input} value={paper.title} onChange={(e) => set({ title: e.target.value })} placeholder="e.g. Class 8 Science – PT1" />
        <div style={ui.grid2}>
          <div><span style={ui.label}>Class</span>
            <select style={ui.input} value={paper.classId} onChange={(e) => set({ classId: e.target.value })}>
              <option value="">Select…</option>{classes.map((c) => <option key={c} value={c}>{c}</option>)}
            </select></div>
          <div><span style={ui.label}>Section</span><input style={ui.input} value={paper.section} onChange={(e) => set({ section: e.target.value })} placeholder="A" /></div>
          <div><span style={ui.label}>Subject</span>
            <select style={ui.input} value={paper.subject} onChange={(e) => set({ subject: e.target.value })}>
              <option value="">Select…</option>{subjects.map((s) => <option key={s} value={s}>{s}</option>)}
            </select></div>
          <div><span style={ui.label}>Session</span><input style={ui.input} value={paper.session} onChange={(e) => set({ session: e.target.value })} /></div>
          <div><span style={ui.label}>Examination title</span>
            <input style={ui.input} list="qpb-exams" value={h.examTitle} onChange={(e) => setH({ examTitle: e.target.value })} />
            <datalist id="qpb-exams">{EXAM_TITLES.map((t) => <option key={t} value={t} />)}</datalist></div>
          <div><span style={ui.label}>Time allowed</span><input style={ui.input} value={paper.timeAllowed} onChange={(e) => set({ timeAllowed: e.target.value })} /></div>
        </div>
        <div style={{ ...ui.row, marginTop: 8 }}>
          <label style={{ fontSize: 12 }}><input type="checkbox" checked={paper.maxMarksLocked} onChange={(e) => set({ maxMarksLocked: e.target.checked, maxMarks: e.target.checked ? (paper.maxMarks || autoTotal) : autoTotal })} /> Lock maximum marks</label>
          {paper.maxMarksLocked
            ? <input type="number" min="1" style={{ ...ui.input, width: 90 }} value={paper.maxMarks} onChange={(e) => set({ maxMarks: Number(e.target.value) })} />
            : <b style={{ fontSize: 13 }}>Auto: {autoTotal}</b>}
        </div>
      </div>

      <div style={ui.card}>
        <b style={{ fontSize: 13 }}>Header & branding</b>
        <span style={ui.label}>School name</span><input style={ui.input} value={h.schoolName || ''} onChange={(e) => setH({ schoolName: e.target.value })} />
        <span style={ui.label}>Affiliation / board code</span><input style={ui.input} value={h.affiliation || ''} onChange={(e) => setH({ affiliation: e.target.value })} placeholder="CBSE Affiliation No. …" />
        <div style={{ ...ui.row, marginTop: 8 }}>
          <label style={{ fontSize: 12 }}><input type="checkbox" checked={!!h.showLogo} onChange={(e) => setH({ showLogo: e.target.checked })} /> Show logo</label>
          <input type="file" accept="image/png,image/jpeg,image/webp" onChange={(e) => readLogo(e.target.files[0], (url) => setH({ logoUrl: url }))} style={{ fontSize: 12 }} />
        </div>
        <span style={ui.label}>General instructions (one per line; **bold** / *italic* allowed)</span>
        <textarea style={{ ...ui.input, minHeight: 90 }} value={(h.customInstructions || []).join('\n')} onChange={(e) => setH({ customInstructions: e.target.value.split('\n') })} />
      </div>

      <div style={ui.card}>
        <b style={{ fontSize: 13 }}>Typography & layout</b>
        <div style={ui.grid2}>
          <div><span style={ui.label}>Font size</span>
            <select style={ui.input} value={h.fontSize} onChange={(e) => setH({ fontSize: e.target.value })}>
              <option value="sm">Small</option><option value="md">Medium</option><option value="lg">Large</option></select></div>
          <div><span style={ui.label}>Columns</span>
            <select style={ui.input} value={h.columnLayout} onChange={(e) => setH({ columnLayout: e.target.value })}>
              <option value="single">1 column</option><option value="double">2 columns (compact)</option></select></div>
        </div>
        <span style={ui.label}>Watermark text (optional)</span>
        <input style={ui.input} value={h.watermarkText || ''} onChange={(e) => setH({ watermarkText: e.target.value })} placeholder="School name or leave blank" />
        <label style={{ ...ui.row, fontSize: 12, marginTop: 8 }}><input type="checkbox" checked={!!h.showConfidential} onChange={(e) => setH({ showConfidential: e.target.checked })} /> Show “CONFIDENTIAL” stamp</label>
      </div>
    </div>
  );
}
